export async function getAppLicense(appId) {
  return fetch(`/app-license/?app-id=${encodeURIComponent(appId)}`, {
    credentials: 'same-origin'
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new Error(`Unexpected status code: ${response.status}`);
  });
}

export async function addAppLicense(appId) {
  return fetch('/app-license/', {
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({appId: appId})
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  });
}
